module.exports = __webpack_public_path__ + "static/school_support_img2M@2x-f2b727accdde3b9f28ace60696368e41.jpg";